import React  from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
 

const POSTER_PATH = 'http://image.tmdb.org/t/p/w342'

const Movie = ({ movie }) => ( 
  <article className="movie-single">
    <Link to={`/${movie.id}`}>
      <img src={`${POSTER_PATH}${movie.poster_path}`} alt={movie.title} title={movie.title}/>
    </Link>
   
  </article>  
)

export default Movie

Movie.propTypes = {
  movie: PropTypes.shape({
    title: PropTypes.string.isRequired 
  }).isRequired,
}


// WEBPACK FOOTER //
// ./src/components/Movies/Movie.js